<div class="pcbody">
<div class="portal-card">
  <div class="portal-header">
    <div class="wifi-icon">📶</div>
    <div class="event-name" id="eventName">Conference WiFi</div>
    <div class="subtitle" id="eventSubtitle">Welcome! Please sign in to access the internet.</div>
  </div>

  <div class="portal-body">
    <div id="alertBox" class="alert d-none" role="alert"></div>

    <form id="portalForm">
      <div class="form-group">
        <label for="firstName" class="font-weight-600 text-dark">First Name</label>
        <input type="text" class="form-control" id="firstName" placeholder="John" required>
      </div>
      <div class="form-group">
        <label for="lastName" class="font-weight-600 text-dark">Last Name</label>
        <input type="text" class="form-control" id="lastName" placeholder="Smith" required>
      </div>
      <div class="form-group">
        <label for="email" class="font-weight-600 text-dark">Email Address</label>
        <input type="email" class="form-control" id="email" placeholder="john@example.com" required>
      </div>
      <div class="form-group">
        <label for="company" class="font-weight-600 text-dark">Company <span class="text-muted font-weight-normal">(optional)</span></label>
        <input type="text" class="form-control" id="company" placeholder="Acme Corp">
      </div>

      <div class="divider"></div>

      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="termsCheck" required>
        <label class="form-check-label terms-text" for="termsCheck">
          I agree to the <a href="#" target="_blank">Terms of Service</a> and
          <a href="#" target="_blank">Privacy Policy</a>. I understand that my
          internet usage may be monitored.
        </label>
      </div>

      <button type="submit" class="btn btn-connect btn-primary btn-block text-white mt-3">
        <span class="loading-spinner spinner-border spinner-border-sm mr-2" role="status"></span>
        <span id="btnText">Connect to WiFi</span>
      </button>
    </form>
  </div>

  <div class="sponsor-section">
    <div class="sponsor-label">Sponsored by</div>
    <div class="text-muted font-weight-bold">Your Sponsor Name</div>
  </div>

  <div class="powered-by">
    Powered by <a href="#">BehaviorLive</a>
  </div>
</div>
</div>
